import { useDispatch, useSelector } from 'react-redux'
import InputBox from '../../../common/interactive/InputBox'
import { caseActions } from '../../../../store/case'
import { caseQuickUpdate } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import { atpProvidersOptions } from '../../../../lib/systemData'
import CustomSelect from '../../../common/interactive/CustomSelect'
import { useMemo } from 'react'

import classes from './CaseSummaryControls.module.css'
// import Button from '../../../common/Button'
// import { useState } from 'react'
import GeneratePDFDownload from '../Shared/GeneratePDFDownload'

export default function CaseSummaryControls() {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 
    const atpProviderOptionsData = useMemo(() => atpProvidersOptions(), [])

    // const [loading, setLoading] = useState(false)

    const updateHandlerInput = async (data) => {
       
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        let dispatchObj = {
            folder: data.identifier.folder,
            item: {
                fields: [
                    {
                        field: data.identifier.field,
                        value: data.data.value
                    },
                ]            
            }
        }
        setTimeout(() => {
            dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
        }, 0)

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }      
        
    }

    const updatehandlerSelect = async (value) => {
        let dispatchObj = {
            folder: value.identifier.folder,
            item: {
                fields: [
                    {
                        field: value.identifier.field,
                        value: value.data.value
                    },
                ]            
            }
        }
        setTimeout(() => {
            dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
        }, 0)
        const body = {
            type: value.identifier.type,
            type_id: value.identifier.type_id,
            fields: {
                [value.identifier.field]: value.data.value
            }    
        }
       
        const update = await caseQuickUpdate(userToken, activeCase.case.id, body)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }     
        
    }

    // async function generatePDFHandler() {

    //     setLoading(true)
    //     let response = await generateCaseSummaryPDF(userToken, activeCase.case.id)

    //     if (response && response.errorMessage) {
    //         dispatch(notificationActions.setError(response))     
    //     } else {   
    //         const fileURL = URL.createObjectURL(response)
            
    //         // force download, if not the file needs to be saved firt in the app and then generate a link...
    //         const a = document.createElement("a");
    //         a.href = fileURL;
    //         a.download = "case_summary.pdf"; 
    //         a.click();
            
    //     }

    //     setLoading(false)

    // }

    return <div className={classes.controls}>
        <InputBox currentValue={activeCase.additional.summary_completed_by} label={'Summary Completed By'} type={'text'} name={'summary_completed_by'} action={updateHandlerInput} identifier={{folder: 'additional',type: 'case_additional', field: 'summary_completed_by', type_id: null}} setStyle={'bk_white'} />
        <CustomSelect label={'Consulting Provider'} optionsData={atpProviderOptionsData} preSelectedValue={activeCase?.additional?.consulting_provider_id} action={updatehandlerSelect} identifier={{folder: 'additional',type: 'case_additional', field: 'consulting_provider_id', type_id: null}}/>
        
        {/* <Button click={generatePDFHandler} isLoading={loading}><i className="ti ti-printer"></i>Print</Button> */}
        <GeneratePDFDownload url={'case-summary-pdf'} fileName={'case_summary.pdf'}>
            <i className="ti ti-printer"></i>Print
        </GeneratePDFDownload>
    </div>
}